import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import type { ConnectorType } from 'scaleflow/utils/connectors-config';
import ConnectorIcon from 'scaleflow/components/connectors/icon';
import ArrowLeft from 'scaleflow/components/tailwind-icons/arrow-left';
import CheckCircle from 'scaleflow/components/tailwind-icons/check-circle';

export interface ConnectorsDetailPageSignature {
  Args: { connector: ConnectorType };
  Blocks: {
    badge: [];
    cta: [];
    default: [];
  };
}

const ConnectorsDetailPage: TOC<ConnectorsDetailPageSignature> = <template>
  <div class="overflow-y-auto h-full">
    <div class="w-full max-w-4xl mx-auto px-8 py-8">
      {{! Back link }}
      <LinkTo
        @route="connectors"
        class="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800 mb-8 group"
      >
        <ArrowLeft
          class="w-4 h-4 transition-transform group-hover:-translate-x-0.5"
        />
        Back to Connectors
      </LinkTo>

      {{! Header }}
      <div class="flex items-start gap-6 mb-8">
        <ConnectorIcon @id={{@connector.id}} />
        <div>
          <div class="flex items-center gap-3 mb-2 flex-wrap">
            <h1
              class="text-3xl font-bold text-gray-900"
            >{{@connector.name}}</h1>
            <span
              class="px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700"
            >
              {{@connector.category}}
            </span>
            {{yield to="badge"}}
          </div>
          <p class="text-gray-500 max-w-2xl">{{@connector.longDescription}}</p>
        </div>
      </div>

      {{yield to="cta"}}

      {{! Features grid }}
      {{#if @connector.features.length}}
        <h2 class="text-xl font-bold text-gray-900 mb-4">What you'll get</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          {{#each @connector.features as |feature|}}
            <div class="rounded-lg border bg-white p-5">
              <div class="flex items-start gap-3">
                <CheckCircle class="w-5 h-5 text-primary-500 mt-0.5 shrink-0" />
                <div>
                  <h3
                    class="font-semibold text-gray-900 mb-1"
                  >{{feature.title}}</h3>
                  <p class="text-sm text-gray-500">{{feature.description}}</p>
                </div>
              </div>
            </div>
          {{/each}}
        </div>
      {{/if}}

      {{yield}}
    </div>
  </div>
</template>;

export default ConnectorsDetailPage;
